import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Helpers from "../../utils/helpers";
import { OverlayPanel } from "primereact/overlaypanel";
import { useRef, useState } from "react";
import InviceItems from "./new-invoice-items";

interface InvoiceDataProps {
  invoiceData: any[];
  orderData: any;
}

const InvoiceDataList: React.FC<InvoiceDataProps> = ({ invoiceData, orderData }) => {
  const op = useRef<any>(null);
  const [selectedInvoice, setSelectedInvoice] = useState<any>(null);

  const taxAmountBodyTemplate = (invoice: any) => {
    return Helpers.formatAmountInINR(invoice.invoiceGrossAmount);
  };

  const invoiceDateBodyTemplate = (invoice: any) => {
    const convertedDate = new Date(invoice.invoicedDate);
    const formattedDate = convertedDate.toLocaleDateString("en-gb", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
    return formattedDate;
  };

  const groupedInvoices = invoiceData.reduce((acc: any[], currentInvoice: any) => {
    const existingInvoiceIndex = acc.findIndex((invoice) => invoice.invoiceNo === currentInvoice.invoiceNo);

    if (existingInvoiceIndex === -1) {
      acc.push(currentInvoice);
    } else {
      const existingInvoice = acc[existingInvoiceIndex];
      const currentInvoiceDate = new Date(currentInvoice.invoicedDate);
      const existingInvoiceDate = new Date(existingInvoice.invoicedDate);

      if (currentInvoiceDate > existingInvoiceDate) {
        acc[existingInvoiceIndex] = currentInvoice;
      }
    }

    return acc;
  }, []);

  const showInvoiceItemDetails = (e: any, data: any) => {
    setSelectedInvoice(data);
    op.current.toggle(e);
  };

  return (
    <>
      <DataTable
        value={groupedInvoices}
        tableStyle={{ minWidth: "50rem" }}
        size="small"
        selectionMode="single"
        onSelectionChange={(e) => showInvoiceItemDetails(e.originalEvent, e.value)}
        dataKey="invoiceId"
        header="Invoice"
      >
        <Column field="invoiceNo" header="Invoice #" />
        <Column field="invoicedDate" header="Invoice Date" body={invoiceDateBodyTemplate} />
        <Column field="grossAmount" header="Invoice Amount" body={taxAmountBodyTemplate} />
      </DataTable>

      <OverlayPanel ref={op} showCloseIcon>
        {selectedInvoice && <InviceItems selectedInvoice={selectedInvoice} orderinfo={orderData} />}
      </OverlayPanel>
    </>
  );
};

export default InvoiceDataList;
